module.exports = __webpack_public_path__ + "img/ic_32_sport_volleyball-active.cfb23fa9.svg";